import {z} from 'zod';

import type {LoadedGridPageRequest} from '../types/LoadedGridPageRequest';

const responseSchema = z.object({
  rows: z.array(
    z.object({
      id: z.string().min(1),
      rowNumber: z.number().int(),
      cells: z.record(z.record(z.unknown())),
      actions: z.object({
        primary: z.array(z.string()),
        secondary: z.array(z.string()),
        rowClick: z.string().nullish(),
      }),
    })
  ),
});

/** Wire contract shared by the cached grid adapter and the independent export adapter. */
export const gridDataProtocol = {
  responseSchema,
  pageUrl(params: LoadedGridPageRequest & {gridCode: string}, suffix = '') {
    const search = new URLSearchParams({
      offset: params.offset.toString(),
      limit: params.limit.toString(),
      ...(params.hasSmartSearch && {smartSearch: 'true'}),
    });
    return `/v6/data-grid/${encodeURIComponent(params.gridCode)}/data/${encodeURIComponent(params.queryId)}${suffix}?${search}`;
  },
  normalizeRows(rows: Readonly<z.infer<typeof responseSchema>['rows']>) {
    return rows.map((row) => ({
      ...row.cells,
      id: row.id,
      actions: row.actions,
      rowNumber: row.rowNumber.toString(),
    }));
  },
};
